module.exports = __webpack_public_path__ + "img/kw_logo_mark.26e9be42.jpg";